import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import showdown from 'showdown';

showdown.extension('only-inline-stuff', function() {
  return [
    {
      type: 'output',
      filter: function(text) {
        text = text.replace(/<\/?code[^>]*>/g, '');
        return text;
      },
    },
  ];
});

const markdownConverter = new showdown.Converter({
  extensions: ['only-inline-stuff'],
});

function Typography(props) {
  const {
    className: classNameProp,
    component: componentProp,
    dangerouslySetInnerHTML,
    ...other
  } = props;
  const className = classNames(classNameProp);

  const Component = componentProp || 'p';
  if (dangerouslySetInnerHTML) {
    return (
      <Component
        className={className}
        dangerouslySetInnerHTML={{
          __html: markdownConverter.makeHtml(dangerouslySetInnerHTML.__html),
        }}
        {...other}
      />
    );
  }

  return <Component className={className} {...other} />;
}

Typography.propTypes = {
  /**
   * The content of the component.
   */
  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const Typography = ({prop = val, className = '', component = 'p' }) =>

export default Typography;
